export default __webpack_public_path__ + "static/media/Elation.b28e983c.png";